import axiosInstance from "./axiosInstance";

export const updateConfiguration = async (data: {
  incentiveValue: number;
  conversionValue: number;
  effectiveFrom: string;
  effectiveTo: string;
}) => {
  try {
    const response = await axiosInstance.put("/UpdateConfiguration", data);
    return response.data;
  } catch (error) {
    console.error("Update config failed", error);
    throw error;
  }
};
